import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function ChipIcon({ icon, position }) {
  if (!icon) {
    return null;
  }

  const content = React.isValidElement(icon)
    ? React.cloneElement(icon, {
        className: ["ds-chip__icon-svg", icon.props.className].filter(Boolean).join(" "),
      })
    : icon;

  return (
    <span className={`ds-chip__icon ds-chip__icon--${position}`} aria-hidden="true">
      {content}
    </span>
  );
}

function BaseChip({ className = "", leadingIcon = null, trailingIcon = null, children, ...props }) {
  const classes = ["ds-chip", className].filter(Boolean).join(" ");

  return (
    <span className={classes} {...props}>
      <ChipIcon icon={leadingIcon} position="leading" />
      <span className="ds-chip__label">{children}</span>
      <ChipIcon icon={trailingIcon} position="trailing" />
    </span>
  );
}

const STATUS_ICONS = {
  error: <CancelIcon />,
  warning: <WarningAmberIcon />,
  success: <CheckCircleIcon />,
  info: <InfoIcon />,
};

export default function AppChip({
  variant = "neutral",
  appearance = "outlined",
  size = "md",
  className = "",
  leadingIcon = null,
  trailingIcon = null,
  children,
  ...props
}) {
  const classes = [
    "ds-chip--standard",
    `ds-chip--${variant}`,
    `ds-chip--${appearance}`,
    `ds-chip--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <BaseChip className={classes} leadingIcon={leadingIcon} trailingIcon={trailingIcon} {...props}>
      {children}
    </BaseChip>
  );
}

export function AppStatusChip({
  status = "info",
  size = "md",
  showIcon = true,
  className = "",
  children,
  ...props
}) {
  const classes = [
    "ds-chip--status-family",
    `ds-chip--status-${status}`,
    `ds-chip--${size}`,
    showIcon ? "ds-chip--status-with-icon" : "ds-chip--status-no-icon",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const statusIcon = showIcon ? STATUS_ICONS[status] ?? STATUS_ICONS.info : null;

  return (
    <BaseChip className={classes} leadingIcon={statusIcon} {...props}>
      {children}
    </BaseChip>
  );
}
